export default __webpack_public_path__ + "static/media/signup-splash.1c1740b1.png";